import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLabel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 2C11.55 2 12.0502 2.22008 12.4102 2.58008L21.4102 11.5801C21.7701 11.9401 22 12.4501 22 13C22 13.55 21.7802 14.0502 21.4102 14.4102L14.4102 21.4102C14.0502 21.7802 13.55 22 13 22C12.45 22 11.9498 21.7799 11.5898 21.4199L2.58984 12.4199C2.21991 12.0499 2 11.5499 2 11V4C2 2.9 2.9 2 4 2H11ZM5.5 4C4.67 4 4 4.67 4 5.5C4 6.33 4.67 7 5.5 7C6.33 7 7 6.33 7 5.5C7 4.67 6.33 4 5.5 4Z",
		fill: "currentColor"
	})
});
export default SvgLabel;
